
<template>
  <page-list
    :list="list"
    :columns="columns"
    :group-actions="groupActions"
    :single-actions="singleActions" />
</template>

<script>
import ColumnsMixin from '../mixins/columns'
import singleActionsMixin from '../mixins/singleActions'
import WindowsMixin from '@/mixins/windows'
import ListMixin from '@/mixins/list'

export default {
  name: 'LicenseList',
  mixins: [WindowsMixin, ListMixin, ColumnsMixin, singleActionsMixin],
  props: {
    id: String,
  },
  data () {
    return {
      list: this.$list.createList(this, {
        // id: this.id,
        resource: 'licenserecords',
      }),
      groupActions: [
        /* {
          label: '申请',
          action: () => {
            this.createDialog('CustomApplyLicenseDialog', {
              title: '申请',
              onManager: this.onManager,
            })
          },
          meta: () => ({
            buttonType: 'primary',
          }),
        }, */
      ],
    }
  },
  created () {
    this.list.fetchData()
  },
}
</script>

<style lang="less" scoped>
@import '~@/styles/less/index';
  .status-success {
    color: @success-color;
  }
  .status-danger {
    color: @error-color;
  }
</style>
